// Exports
export default {
	"artifactsLoadingSkeleton": "artifactsLoadingSkeleton_Tx3iH",
	"header": "header_aPN2W",
	"body": "body_lp+tA",
	"oneColLayout": "oneColLayout_OU6ZO"
};
